import Arrive from 'arrive/src/arrive.js';
import machina from 'machina/lib/machina.js';

(function () {
  'use strict';

/*----------------------------------------------------------------------------*/
// Component Base
/*----------------------------------------------------------------------------*/
  var baseConfiguration = {
    initialize: function (options) {
      var self = this;

      self.BIND_PAGE_EVENTS();

      self.INIT(options);

      if (self.config.AUTO_INIT) {
        self.FIND_INSTANCES_IN_CONTAINER();
      }

    },
    initialState: 'UNMOUNTED',
    states: {
      UNMOUNTED: {
        '*': function ( /*instance*/ ) {
          //var self = this;


        },
        'MOUNT': function ( instance ) {
          var self = this;

          self.deferUntilTransition( instance );

          self.transition( instance, 'MOUNTED');

        }
      }
    },
    BIND_PAGE_EVENTS: function () {
      var self = this;

      // Evento del plugin Arrive.js - Creación de un bloque de html del componente
      jQuery(document).arrive(
        this.config.ELEMENT_SELECTOR,
        function () {
          jQuery(this).trigger('dy_component.arrive');
        }
      );
      jQuery(document).on('dy_component.arrive',
        self.config.ELEMENT_SELECTOR,
        function(localSelf, event) {

          event.preventDefault();
          event.stopPropagation();

          if (localSelf.config.AUTO_INIT) {
            localSelf.FIND_INSTANCE(event.target);
          }

        }.bind(null, self)
      );

      // Evento del plugin Arrive.js - Destrucción de un bloque de html del componente
      jQuery(document).leave(
        this.config.ELEMENT_SELECTOR,
        function () {
          window.dy_component.destroy_instance(this);
        }
      );



      // Esperamos a un aviso externo para destruir componentes esclavos
      if (self.config.AUTO_INIT === false) {

        jQuery(document).on('dy_component.destroy_delayed_components',
          function(localSelf, event) {

            event.preventDefault();
            event.stopPropagation();

            localSelf.DELETE_INSTANCES_IN_CONTAINER(jQuery(event.target) );

          }.bind(null, self)
        );
      }



      // Evento del módulo de navigator
      jQuery(document).on('dy_navigator.pageLoad',
        function(localSelf, event) {

          event.preventDefault();
          event.stopPropagation();

          localSelf.FIND_INSTANCES_IN_CONTAINER(jQuery(event.target) );

        }.bind(null, self)
      );

      // Evento del módulo de navigator
      jQuery(document).on('dy_navigator.pageUnload',
        function(localSelf, event) {

          event.preventDefault();
          event.stopPropagation();

          localSelf.DELETE_INSTANCES_IN_CONTAINER(jQuery(event.target) );

        }.bind(null, self)
      );

    },
    DELETE_INSTANCES_IN_CONTAINER: function (parentElementJquery) {
      var self = this;

      parentElementJquery = parentElementJquery || jQuery('body');

      parentElementJquery.find(self.config.ELEMENT_SELECTOR).each(
        function( /*index*/ ) {
          self.DELETE_INSTANCE(this);
        }
      );
    },
    DELETE_INSTANCE: function (elementHtml) {
      var self = this;

      if (elementHtml.id !== null && elementHtml.id !== '') {
        if( elementHtml.id.indexOf(self.config.ELEMENT_ID) >= 0){
          // Avisamos a la instancia de que va a ser destruida
          self.transition( self.INSTANCES_POOL[elementHtml.id], 'TOBEDESTROYED');

          delete self.INSTANCES_POOL[elementHtml.id];
        }
      }
    },
    FIND_INSTANCES_IN_CONTAINER: function (parentElementJquery) {
      var self = this;

      parentElementJquery = parentElementJquery || jQuery('body');

      parentElementJquery.find(self.config.ELEMENT_SELECTOR).each(
        function( /*index*/ ) {
          self.FIND_INSTANCE(this);
        }
      );

    },
    FIND_INSTANCES_FROM_CHILD: function ( childElementJquery ) {
      var self = this;

      var parent = childElementJquery.closest(self.config.ELEMENT_SELECTOR)[0];

      return self.FIND_INSTANCE(parent);

    },
    FIND_INSTANCE: function (elementHtml) {
      var self = this;

      var instance = null;
      var isMarked = false;

      // Comprobamos que se trate de un elemento html con la clase del componente
      if (jQuery(elementHtml).is(self.config.ELEMENT_SELECTOR) ) {

        if (elementHtml.id !== null && elementHtml.id !== '') {

          if( elementHtml.id.indexOf(self.config.ELEMENT_ID) >= 0){
            isMarked = true;
          } else {
            isMarked = false;
          }

        } else {
          isMarked = false;
        }

        if (isMarked) {
          instance = self.INSTANCES_POOL[elementHtml.id];
        } else {

          self.INSTANCES_COUNTER = self.INSTANCES_COUNTER + 1;

          var elementJquery = jQuery(elementHtml);
          var id = self.config.ELEMENT_ID + self.INSTANCES_COUNTER;

          // Marcamos el tag html actual con el id
          elementJquery.attr('id', id);

          // Buscamos todos los subelementos de la instancia
          var subElements = self.FIND_SUBELEMENTS(elementJquery);

          // Buscamos todos los subComponentes de la instancia
          var subComponents = self.FIND_SUBCOMPONENTS(elementJquery);

          // Añadimos el objeto al pool de instancias
          self.INSTANCES_POOL[id] = {
              elementHtml: elementHtml,
              elementJquery: elementJquery,
              id: id,
              subElements: subElements,
              subComponents: subComponents
          };

          // Devolveremos la instancia
          instance = self.INSTANCES_POOL[id];

          // Inicializamos la instancia de Machine
          self.handle( instance, 'MOUNT' );

        }

      }

      return instance;

    },
    FIND_SUBELEMENTS: function (elementJquery) {
      var self = this;

      var subElements = {};

      for (var i = 0; i < self.config.SUB_ELEMENTS_SELECTORS.length; i++) {
        subElements[self.config.SUB_ELEMENTS_SELECTORS[i]] = elementJquery.find('.' + self.config.SUB_ELEMENTS_SELECTORS[i]);
      }

      return subElements;

    },
    FIND_SUBCOMPONENTS: function (elementJquery) {
      var self = this;

      var subComponents = {};

      for (var i = 0; i < self.config.SUB_COMPONENTS_SELECTORS.length; i++) {
        subComponents[self.config.SUB_COMPONENTS_SELECTORS[i]] = elementJquery.find('.' + self.config.SUB_COMPONENTS_SELECTORS[i]);
      }

      return subComponents;

    },
    UPDATE_STATE_CLASS: function ( instance ) {
      var self = this;

      var machinaName = '__machina__';

      var current_state = instance[machinaName][self.namespace].state;

      // Remove other states
      var classes = instance.elementHtml.className.split(' ').filter(function(c) {
          return c.lastIndexOf('st_', 0) !== 0;
      });

      // Add current State class
      classes.push('st_' + current_state);

      // Reasign Classes
      instance.elementHtml.className = jQuery.trim(classes.join(' '));

      // Log new state
      self.LOG('st_' + current_state);

    },
    GET_STATE: function ( instance ) {
      var self = this;

      var machinaName = '__machina__';

      var current_state = instance[machinaName][self.namespace].state;

      return current_state;

    },
    PROCESS_ALL_INSTANCES: function ( function_name ) {
      var self = this;

      // Recorremos todas las instancias del pool
      for (var key in self.INSTANCES_POOL) {
        if (self.INSTANCES_POOL.hasOwnProperty(key)) {
          self.LOG(key + ' -> ' + self.INSTANCES_POOL[key]);

          self[function_name](self.INSTANCES_POOL[key]);
        }
      }
    },
    LOG: function (message) {
      var self = this;

      if ( self.config.DEBUGGING === true ) {

        console.log(self.config.ELEMENT_SELECTOR);
        console.log(message);
        console.log('---------------------------------------------');
      }

    },

    INSTANCES_POOL: {},
    INSTANCES_COUNTER: 0
  };

/*----------------------------------------------------------------------------*/
// Factory Constructor
/*----------------------------------------------------------------------------*/
  var dy_component = function () {

  };

/*----------------------------------------------------------------------------*/
// Factory Extend
/*----------------------------------------------------------------------------*/

  dy_component.prototype.extend = function (config_machina) {

    var newMachine = jQuery.extend( true, {}, baseConfiguration, config_machina);

    return machina.BehavioralFsm.extend(newMachine);

  };


/*----------------------------------------------------------------------------*/
// Destroy instance
/*----------------------------------------------------------------------------*/

  dy_component.prototype.destroy_instance = function (element_html) {

    var id = jQuery(element_html).attr('id');

    var component_name = '';

    // Comprobamos que tenga un ID
    if (id !== '' && id !== undefined) {

      // Comprobamos que sea un ID de un componente
      if ( id.substring(0, 3) === 'cm_' ) {
        // Averiguamos de que componente se trata
        var split = id.split('_');
        component_name = 'cm';

        for (var i = 1; i < split.length; i++) {
          // Comprobamos que no se trate de un número
          if ( isNaN(split[i]) ) {
            component_name = component_name + '_' + split[i];
          }
        }

      }

    }

    // Si tenemos el nombre del componente
    if ( component_name !== '' ) {

      // Si el componente existe en la página
      if (window[component_name]) {

        // Si el componente está configurado para autoinicializarse
        if ( window[component_name].config.AUTO_INIT ) {
          window[component_name].DELETE_INSTANCE(element_html);
        }
      }
    }

  };

/*----------------------------------------------------------------------------*/
// Factory Instantation
/*----------------------------------------------------------------------------*/

    window.dy_component = new dy_component();


}());

